export enum PaymentOptionsFlowStep {
  MethodSelection = 'method-selection',
  CurrencySelection = 'currency-selection',
  SolanaPayWalletSelection = 'solana-pay-wallet-selection',
}

export const stepOrder = [
  PaymentOptionsFlowStep.MethodSelection,
  PaymentOptionsFlowStep.CurrencySelection,
  PaymentOptionsFlowStep.SolanaPayWalletSelection,
];
